import { render, staticRenderFns } from "./carDetailHisFee.vue?vue&type=template&id=12159192"
import script from "./carDetailHisFee.vue?vue&type=script&lang=js"
export * from "./carDetailHisFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports